<!-- Top bar -->
<mat-toolbar class="topBar">
  <div style="display:flex; align-items:center; gap: 10px;">

    <!-- Back to Sets -->
    <button mat-mini-fab
            class="topButton"
            type="button"
            aria-label="Example icon-button with menu icon"
            [matTooltip]="matToolTipText"
            matTooltipPosition="below"
            (click)="navigateBack()">
      <mat-icon>
        arrow_back
      </mat-icon>
    </button>

    <!-- Back to Home -->
    <button mat-mini-fab
            class="topButton"
            type="button"
            matTooltip="Back to Home"
            matTooltipPosition="below"
            (click)="router.navigate(['menu'])">
      <mat-icon>
        home
      </mat-icon>
    </button>

  <span *ngIf="viewMode == 0">Current Delivery</span>
  <span *ngIf="viewMode == 1">Logbook</span>
  <span *ngIf="viewMode == 2">Editing Logbook</span>  
  </div>   

  <span class="spacer"></span>

  <mat-spinner *ngIf="dataSync.sync_in_progress()" [diameter]="35" class="mat-spinner-color"></mat-spinner>
  <!-- Enable edits -->
  <button mat-stroked-button
          *ngIf="viewMode != 0"
          class="edit-button"
          type="button"
          [hidden]="!canEdit"
          matTooltipPosition="below"
          (click)="viewMode == 1 ? enableEdits() : discardEdits(true)">
    <span *ngIf="viewMode == 1">
      Edit
    </span>
    <span *ngIf="viewMode == 2">
      Cancel
    </span>
  </button>

</mat-toolbar>

<div class="container" style="padding-top: 15px; max-width: none;">

    <form [formGroup]="landingForm">

      <div class="row">
        <mat-form-field>
          <mat-label>Vessel</mat-label>
          <mat-select formControlName="vessel" [compareWith]="compareVessel" required>
            <mat-option *ngFor="let v of vesselOptions()" [value]="v">{{v}}</mat-option>
            <mat-option (click)="addVessel()">
              Add New
            </mat-option>
          </mat-select>
          <mat-error *ngIf="landingForm.invalid">Required</mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field>
          <mat-label>Vessel Operator</mat-label>
          <input matInput formControlName="operator" required>
          <mat-error *ngIf="landingForm.invalid">Required</mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field>
          <mat-label>
            Landing Date
          </mat-label>
          <input matInput readonly formControlName="deliverDate" (click)="editDateTime()" required>
          <mat-error *ngIf="landingForm.invalid">Required</mat-error>
        </mat-form-field>
      </div>


      <!-- This will be an auto-complete -->
      <div class="row">
        <mat-form-field>
          <mat-label>Port of Landing</mat-label>
          <input matInput formControlName="landingPort" [matAutocomplete]="auto" required>
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let option of filteredPorts | async" [value]="option">
              {{option}}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="landingForm.invalid">Select an item</mat-error>
        </mat-form-field>
      </div>

      <div class="row align-items-center">
        <div class="col">
          <h3>Permit Type</h3>
        </div>

        <div class="col" style="padding-left: 0px;">
          <div class="row">
            <mat-form-field style="padding-left: 0px;">
              <mat-label>Permit Type</mat-label>
              <mat-select formControlName="permitType" hideSingleSelectionIndicator="true" [compareWith]="compareFn" required>
                @for (type of permitTypeOptions; track type.id) {
                  <mat-option [value]="type">
                    {{type}}
                  </mat-option>
                }             
              </mat-select>
              <mat-error *ngIf="landingForm.invalid">Required</mat-error>
            </mat-form-field>
          </div>

        </div>

      </div>

      <!-- Permit Number -->
      <div class="row align-items-center" style="margin-bottom: 25px;">

        <div class="col-6">
          <h3 [ngClass]="permitNumControl.enabled ? [] : ['faded']">
            Permit Number
          </h3>
        </div>
          
        <div class="col-6" style="padding-left: 0px;">
          <div class="row">
            <mat-form-field appearance="outline" style="padding-left: 0px;">
              <span matTextPrefix *ngIf="landingForm.get('permitType')?.value?.name === 'IFQ'
                    || landingForm.get('permitType')?.value?.name === 'LE Fixed Gear'"
                  [ngClass]="permitNumControl.enabled ? ['prefixText'] : ['faded']">
                GF
              </span>
              <span matTextPrefix *ngIf="landingForm.get('permitType')?.value?.name === 'Open Access'"
                    [ngClass]="permitNumControl.enabled ? ['prefixText'] : ['faded']">
                DOAG
              </span>
              <mat-label style="padding-left: 15px;">Permit #</mat-label>
              <mat-select style="padding-left: 15px;" [formControl]="permitNumControl" hideSingleSelectionIndicator="true" name="permitNum" required>
                <mat-option *ngFor="let num of filteredPermitNums" [value]="num">
                  {{num}}
                </mat-option>
                <mat-option (click)="openPermitDialog()">
                  Add New
                </mat-option>
              </mat-select>
              <mat-error *ngIf="permitNumControl.invalid">Required</mat-error>
            </mat-form-field>
          </div>
          
        </div>

            

          

          

          </div>

      <div class="row align-items-center">
        <div class="col">
          <h3>Exempted Fishing Permit?</h3>
        </div>

        <div class="col">
          <div class="row" style="margin-bottom: 16px;">
            <mat-radio-group aria-label="Select an option" formControlName="isExemptedFP">
              <mat-radio-button [checked]="landingForm.get('isExemptedFP')?.value" [value]="true">Yes</mat-radio-button>
              <mat-radio-button [checked]="!landingForm.get('isExemptedFP')?.value" [value]="false" style="padding-left: 25px;">No</mat-radio-button>
            </mat-radio-group>
          </div>

        </div>

      </div>

      <div *ngIf="landingForm.get('permitType')?.value?.name === 'IFQ'" class="row align-items-center">
        <div class="col">
          <h3>EM Video Monitoring?</h3>
        </div>

        <div class="col">
          <div class="row" style="margin-bottom: 16px;">
            <mat-radio-group aria-label="Select an option" formControlName="isEMTrip">
              <mat-radio-button [checked]="landingForm.get('isEMTrip')?.value" [value]="true">Yes</mat-radio-button>
              <mat-radio-button [checked]="!landingForm.get('isEMTrip')?.value" [value]="false" style="padding-left: 25px;">No</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>

      </div>

      <div class="row align-items-center">
        <div class="col">
          <h3>Observed Trip?</h3>
        </div>

        <div class="col">
          <div class="row" style="margin-bottom: 16px;">
            <mat-radio-group aria-label="Select an option" formControlName="isObservedTrip">
              <mat-radio-button [checked]="landingForm.get('isObservedTrip')?.value" [value]="true">Yes</mat-radio-button>
              <mat-radio-button [checked]="!landingForm.get('isObservedTrip')?.value" [value]="false" style="padding-left: 25px;">No</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>

      </div>

      <div *ngIf="landingForm.hasError('monitoring')" class="row">
        <div class="col">
          <span class="validation-error">IFQ trips must select 'yes' for either observer or EM monitoring</span>
        </div>
      </div>

    </form>

        <div class="row">
          <mat-toolbar style="background-color: var(--elog-brand); color: var(--elog-brand-on); border-bottom: 3px solid var(--elog-accent-strong);">
            <span>Fish Tickets</span>
            <span class="spacer"></span>

            <!-- Add Fish Ticket -->
            <button mat-mini-fab
                    *ngIf="viewMode != 1"
                    class="blue-icon-button"
                    type="button"
                    aria-label="Example icon-button with share icon"
                    matTooltip="Add Fish Ticket"
                    matTooltipPosition="below"
                    (click)="openFishTicketDialog(landing.tickets.length)">
              <mat-icon>
                add
              </mat-icon>
            </button>
          </mat-toolbar>
        </div>

        <div class="row">

            <table mat-table [dataSource]="landing.tickets" class="mat-elevation-z8">

                <!-- Buyer Column  -->
                <ng-container matColumnDef="Buyer">
                  <tr>
                    <th mat-header-cell *matHeaderCellDef> Buyer </th>
                    <td mat-cell *matCellDef="let tck"> {{tck.buyer}} </td>
                  </tr>
                </ng-container>

                <!-- Fish Ticket # Column -->
                <ng-container matColumnDef="Fish Ticket Number">
                  <tr>
                    <th mat-header-cell *matHeaderCellDef> Fish Ticket Number </th>
                    <td mat-cell *matCellDef="let tck"> {{tck.ticketNumber}} </td>
                  </tr>
                </ng-container>

                <!-- Date Column -->
                <ng-container matColumnDef="Date">
                  <tr>
                    <th mat-header-cell *matHeaderCellDef> Date </th>
                    <td mat-cell *matCellDef="let tck"> {{tck.deliveryDate | date:'MMM-dd-yy'}} </td>
                  </tr>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="fishTicketColumns"></tr>
                <tr mat-row (click)="openFishTicketDialog(index)" *matRowDef="let row; columns: fishTicketColumns; let index=index;"></tr>

            </table>

        </div>

        <div class="row">
          <mat-toolbar style="background-color: var(--elog-brand); color: var(--elog-brand-on); border-bottom: 3px solid var(--elog-accent-strong);">
            <span>Sets Included in Delivery</span>
            <span class="spacer"></span>

            <!-- Add Set to Delivery -->
            <button mat-mini-fab
                    *ngIf="viewMode != 1"
                    class="blue-icon-button"
                    type="button"
                    aria-label="Example icon-button with share icon"
                    matTooltip="Add Set to Delivery"
                    matTooltipPosition="below"
                    (click)="openSetSelection()">
              <mat-icon>
                add
              </mat-icon>
            </button>
          </mat-toolbar>

        </div>

        <div class="row">
            <div *ngFor="let set of sortedSets; let index=index;" style="padding-left: 0px; padding-right: 0px; font-size: 16px;">
                <mat-card matRipple (click)="goToSet(set.fishingEventID)" style="padding:16px;">
                    <div class="container">
                        <div class="row">
                            <div class="col-5">
                                <span *ngIf="set.setNumber == ''" style="font-size: small; font-weight: lighter; font-style: italic;">&lt;No String/Set#&gt;</span><b>{{set.setNumber}}</b>
                            </div>
                            <div class="col-6">
                                <b>Set: </b>{{set.startDate | date:'HH:mm, EE, MMM.dd'}}
                                <br>
                                <b>Retrieval: </b>{{set.endDate | date:'HH:mm, EE, MMM.dd'}}
                            </div>
                            <div class="col-1">
                                <!--ONLY if set has no errors - maybe color code the card?-->
                                <mat-icon *ngIf="viewMode == 1 || validSets.get(set.fishingEventID)">done</mat-icon>
                                <mat-icon *ngIf="viewMode != 1 && !validSets.get(set.fishingEventID)">error</mat-icon>  
                            </div>
                        </div>
                    </div>
                    <mat-card-actions *ngIf="viewMode != 1 && !preExistingSets.get(set.fishingEventID)">
                      <button mat-fab
                              class="text-button"
                              type="button"
                              (click)="removeSet(index)">
                        Remove
                      </button>
                    </mat-card-actions>
                    <mat-card-footer></mat-card-footer>
                </mat-card>   
                <br>               
            </div>    
        </div>

        <br>
        <br>
        <br>
        <br>
        <br>
</div>


<!-- Bottom bar -->
<mat-toolbar class="toolbarNav">
  <div class="example-button-container">

    <!-- Delivery Summary -->
    <button mat-fab
            class="bottom-toolbar-button"
            type="button"
            aria-label="Example icon button with a plus one icon"
            matTooltip="Summary"
            matTooltipPosition="above"
            (click)="router.navigate(['summary_report', 'Groundfish', viewMode == 0 ? -1 : this.completedInd], { queryParams: { previous: previousScreen } })">
      <mat-icon>
        description
      </mat-icon>
    </button>
  </div>

  <!-- Delivery Errors -->
  <div *ngIf="errors.length > 0 && viewMode != 1" class="example-button-container">
    <button mat-fab
            class="bottom-toolbar-button"
            type="button"
            aria-label="Example icon button with a plus one icon"
            matTooltip="Errors/Warnings"
            matTooltipPosition="above"
            (click)="openErrorDialog()">
      <mat-icon *ngIf="onlyWarnings">
        warning
      </mat-icon>
      <mat-icon *ngIf="!onlyWarnings">
        report
      </mat-icon>
    </button>
  </div>

  <!-- Submit Delivery -->
  <div *ngIf="viewMode != 1" class="example-button-container">
    <button mat-fab
            class="bottom-toolbar-button"
            type="button"
            aria-label="Example icon button with a plus one icon"
            matTooltip="Submit Delivery"
            matTooltipPosition="above"
            (click)="openSubmitDialog()">
      <mat-icon>
        drive_folder_upload
      </mat-icon>
    </button>
  </div>
</mat-toolbar>
